// noinspection ES6PreferShortImport
import { ProductError } from '../models/error';

export class GameContext {
  /**
   * Titre de l'onglet dans le navigateur
   */
  titleTab?: string;
  /**
   * Titre sur l'écran d'introduction
   */
  title?: string;
  /**
   * Sous-titre sur l'écran d'introduction
   */
  subtitle?: string;
  /**
   * Description du contenu de la lesson
   */
  lesson?: string;
  /**
   * Règle du jeu
   */
  rules?: string;
  /**
   * Explication détaillée
   */
  explanation?: string;
  /**
   * Phrase neutre de fin de jeu
   * En fin de jeu, si les trophées sont désactivés, il n'y a pas de possibilités de déterminer s'il y a une victoire ou un défaite
   */
  neutralSentence?: string;
  /**
   * Prase en cas de victoire
   */
  victorySentence?: string;
  /**
   * Phrase en cas de défaite
   */
  failSentence?: string;
  /**
   * Si présent plusieurs message (victoire / défaite)
   */
  differentiateFailMessage?: boolean;
  /**
   * Si présent propose au utilisateur de télécharger une fiche pratique en fin de jeu
   */
  leafletUrl?: string;
  /**
   * L'auteur du contenu pédagogique
   */
  author?: string;
  /**
   * Durée estimé pour réaliser le jeu (format {h}:{min}:{sec}.{ms})
   */
  duration?: string;
  /**
   * Durée estimé pour réaliser le jeu en seconde
   */
  durationSeconds?: number;
  /**
   * Durée estimé pour réaliser le jeu en seconde
   */
  nbTimeDone?: number;

  isSimplify?: boolean;

  isInVideoInteractive?: boolean;

  constructor(context?: GameContext) {
    this.titleTab = context?.titleTab;
    this.title = context?.title;
    this.subtitle = context?.subtitle;
    this.rules = context?.rules;
    this.explanation = context?.explanation;
    this.neutralSentence = context?.neutralSentence;
    this.victorySentence = context?.victorySentence;
    this.failSentence = context?.failSentence;
    this.leafletUrl = context?.leafletUrl;
    this.author = context?.author;
    this.duration = context?.duration;
    this.durationSeconds = context?.durationSeconds ?? 0;
    this.differentiateFailMessage = context?.differentiateFailMessage ?? false;
    this.nbTimeDone = context?.nbTimeDone ?? 0;
    this.isSimplify = context?.isSimplify ?? false;
    this.isInVideoInteractive = context?.isInVideoInteractive ?? false;
  }

  static validate(context: GameContext, parentPath: string, payloadData: any): ProductError[] {
    const sentenceFields = [];
    if (!context.isSimplify) {
      if (context.differentiateFailMessage) {
        sentenceFields.push('victorySentence', 'failSentence');
      } else {
        sentenceFields.push('neutralSentence');
      }
    }
    const validators = [...sentenceFields, 'title'];
    if (!context.isSimplify) {
      validators.push('explanation', 'rules');
    }
    return ProductError.validatePrimitiveTypes(context, validators).map(error => ({
      ...error,
      property: `${parentPath}.${error.property}`,
      payload: { ...payloadData },
    }));
  }
}
